import {useDispatch, useSelector} from 'react-redux';
import { fetchDashboardFilters, fetchDashboardFilterData, fetchDashboardOverview,
   fetchStudentCountBySchools, fetchSubmoduleStats, fetchSubmoduleDetails, fetchModuleStats } from "@store/actions/adminDashboardActions";
import {AppState, AppDispatch} from '../store';
import { setAdminDashboardFilterSelected } from '@store/reducers/adminDashboardReducer';
import { clearSubModuleStats,clearModuleStats,clearSubmoduleDetails} from '@store/reducers/adminDashboardReducer';
type dashboardDataFilterParams = {
  province?: string,
  district?: string,
  ward?: string,
  school_ids?: string,
  class_ids?: string,
  module_ids?: string,
  user_ids?: string,
  date_from?: string,
  date_to?: string,
  start_date?: string,
  end_date?: string
  page?: number;
  page_size?: number;
}

export function useAdminDashboard() {
  
  const dispatch: AppDispatch = useDispatch();
  
  const adminDashboardData = useSelector((state: AppState) => state.adminDashboard.adminDashboardData)
  const dashboardOverviewData = useSelector((state: AppState) => state.adminDashboard.dashboardOverviewData)
  const studentCountBySchools = useSelector((state: AppState) => state.adminDashboard.studentCountBySchools)
  const adminDashboardFilter = useSelector((state: AppState) => state.adminDashboard.adminDashboardFilter)
  const adminDashboardFilterSelected = useSelector((state: AppState) => state.adminDashboard.adminDashboardFilterSelected)
  const loading = useSelector((state: AppState) => state.adminDashboard.loading)
  
  // Exercise chart data
  const submoduleStats = useSelector((state: AppState) => state.adminDashboard.submoduleStats)
  const submoduleDetails = useSelector((state: AppState) => state.adminDashboard.submoduleDetails)
  const moduleStats = useSelector((state: AppState) => state.adminDashboard.moduleStats)
  const exerciseChartsLoading = useSelector((state: AppState) => state.adminDashboard.exerciseChartsLoading)
  const subModuleDetailsChartsLoading = useSelector((state: AppState) => state.adminDashboard.subModuleDetailsChartsLoading)
  const moduleStatsLoading = useSelector((state: AppState) => state.adminDashboard.moduleStatsChartLoading)
  
  const fetchDashboardFiltersAction = (filters: dashboardDataFilterParams) => {
    dispatch(fetchDashboardFilters(filters))
  }

  const fetchDashboardFilterDataAction = (filters: dashboardDataFilterParams) => {
    dispatch(fetchDashboardFilterData(filters))
  }

  const fetchDashboardOverviewAction = () => {
    dispatch(fetchDashboardOverview());
  }

  const fetchStudentCountBySchoolsAction = (params: dashboardDataFilterParams) => {
    dispatch(fetchStudentCountBySchools(params));
  }

  const fetchSubmoduleStatsAction = (params: dashboardDataFilterParams) => {
    dispatch(fetchSubmoduleStats(params));
  }

  const fetchSubmoduleDetailsAction = (params: dashboardDataFilterParams) => {
    dispatch(fetchSubmoduleDetails(params));
  }

  const fetchModuleStatsAction = (params: dashboardDataFilterParams) => {
    dispatch(fetchModuleStats(params));
  }

  const updateAdminDashboardFilterSelected = (filters: dashboardDataFilterParams) => {
    dispatch(setAdminDashboardFilterSelected(filters))
  }

  const clearSubModuleStatsAction = () =>{
    dispatch(clearSubModuleStats())
  }
  const clearModuleStatsAction = () =>{
    dispatch(clearModuleStats())
  }
  const clearSubModuleDetailsAction = () =>{
    dispatch(clearSubmoduleDetails())
  }
  return {
    adminDashboardData,
    dashboardOverviewData,
    studentCountBySchools,
    adminDashboardFilter,
    fetchDashboardFiltersAction,
    fetchDashboardFilterDataAction,
    fetchDashboardOverviewAction,
    fetchStudentCountBySchoolsAction,
    updateAdminDashboardFilterSelected,
    adminDashboardFilterSelected,
    loading,
    // Exercise chart data
    submoduleStats,
    submoduleDetails,
    moduleStats,
    exerciseChartsLoading,
    fetchSubmoduleStatsAction,
    fetchSubmoduleDetailsAction,
    fetchModuleStatsAction,
    subModuleDetailsChartsLoading,
    moduleStatsLoading,
    clearSubModuleStatsAction,
    clearModuleStatsAction,
    clearSubModuleDetailsAction
  }
}
